var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 56H38.5C36.575 56 35 54.425 35 52.5H10.535V66.5C10.535 70.35 13.685 73.5 17.535 73.5H66.5C70.35 73.5 73.5 70.35 73.5 66.5V52.5H49C49 54.425 47.425 56 45.5 56ZM70 24.5H56C56 16.765 49.735 10.5 42 10.5C34.265 10.5 28 16.765 28 24.5H14C10.15 24.5 7 27.65 7 31.5V42C7 45.885 10.115 49 14 49H35V45.5C35 43.575 36.575 42 38.5 42H45.5C47.425 42 49 43.575 49 45.5V49H70C73.85 49 77 45.85 77 42V31.5C77 27.65 73.85 24.5 70 24.5ZM35 24.5C35 20.65 38.15 17.5 42 17.5C45.85 17.5 49 20.65 49 24.5H34.965H35Z",
    fill: "#6AA5AC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.946977396801d527f39586f0279c9737.svg";
export { ForwardRef as ReactComponent };